import { Map } from "immutable";

import { ContentType } from "@seneca/course-service-types";

import { getAssignment } from "seneca-common/features/assignments/state";

import StudentAssignment from "../../../models/StudentAssignment";
import * as studentAssignment from "./assignment/studentAssignment";

export {
  assignmentIncludesExamQuestions,
  getAssignment,
  getAssignmentClassId,
  getAssignmentContentIds,
  getAssignmentContentIdsForSection,
  getAssignmentCourseId,
  getAssignmentCutoffDate,
  getAssignmentDueDate,
  getAssignmentExamQuestionIds,
  getAssignmentName,
  getAssignmentNumberOfSections,
  getAssignmentQuizIds,
  getAssignmentQuizTitle,
  getAssignmentsByUserId,
  getAssignmentSectionIds,
  getAssignmentSpec,
  getAssignmentSpecType,
  getAssignmentStartDate,
  getAssignmentStatus,
  getAssignmentWordIds,
  getClassAssignments,
  getFilteredAndSortedAssignments,
  getFutureAssignments,
  getNextDueAssignmentId,
  getNumberOfUpcomingAssignments,
  getVisibleAndFilteredAssignments,
  getVisibleAndSortedAssignments,
  hasMoreThanOneAssignment,
  isAssignmentQuizzesOnly
} from "seneca-common/features/assignments/state";
export {
  getAssignmentSectionBestScore,
  getAssignmentSectionStat,
  getAssignmentVocabularyStats,
  getAssignmentWordBestScore,
  getNumberOfQuestionsCompleted,
  getNumberOfSectionsCompleted,
  getQuizIds
} from "./assignment/studentAssignment";

export function sectionHasBeenStudied(
  assignments: Map<string, StudentAssignment>,
  assignmentId: string,
  sectionId: string
) {
  const assignment = getAssignment(assignments as any, assignmentId);
  return studentAssignment.sectionHasBeenStudied(assignment as any, sectionId);
}

export function sectionContentHasBeenStudied(
  assignments: Map<string, StudentAssignment>,
  assignmentId: string,
  sectionId: string,
  contentType: ContentType
) {
  const assignment = getAssignment(assignments as any, assignmentId);
  return studentAssignment.sectionContentHasBeenStudied(
    assignment as any,
    sectionId,
    contentType
  );
}

export function questionHasBeenStudied(
  assignments: Map<string, StudentAssignment>,
  assignmentId: string,
  questionId: string
) {
  const assignment = getAssignment(
    assignments as any,
    assignmentId
  ) as StudentAssignment;

  return !!studentAssignment.getAssignmentQuestionStat(assignment, questionId);
}

export function quizHasBeenStudied(
  assignments: Map<string, StudentAssignment>,
  assignmentId: string,
  quizId: string
) {
  const assignment = getAssignment(
    assignments as any,
    assignmentId
  ) as StudentAssignment;

  return !!studentAssignment.getAssignmentQuizStat(assignment, quizId);
}

export function getAssignmentAggregatedQuestionsMarks(
  assignments: Map<string, StudentAssignment>,
  assignmentId: string
) {
  const assignment = getAssignment(
    assignments as any,
    assignmentId
  ) as StudentAssignment;
  return studentAssignment.getAssignmentAggregatedQuestionsMarks(assignment);
}

export function getAssignmentQuestionStat(
  assignments: Map<string, StudentAssignment>,
  assignmentId: string,
  questionId: string
) {
  const assignment = getAssignment(
    assignments as any,
    assignmentId
  ) as StudentAssignment;

  return studentAssignment.getAssignmentQuestionStat(assignment, questionId);
}

export function getAssignmentQuizStat(
  assignments: Map<string, StudentAssignment>,
  assignmentId: string,
  quizId: string
) {
  const assignment = getAssignment(
    assignments as any,
    assignmentId
  ) as StudentAssignment;

  return studentAssignment.getAssignmentQuizStat(assignment, quizId);
}

export function getAssignmentQuestionMark(
  assignments: Map<string, StudentAssignment>,
  assignmentId: string,
  questionId: string
) {
  const assignment = getAssignment(
    assignments as any,
    assignmentId
  ) as StudentAssignment;

  return studentAssignment.getAssignmentQuestionMark(assignment, questionId);
}

export function getAssignmentQuestionMarksTotal(
  assignments: Map<string, StudentAssignment>,
  assignmentId: string,
  questionId: string
) {
  const assignment = getAssignment(
    assignments as any,
    assignmentId
  ) as StudentAssignment;

  return studentAssignment.getAssignmentQuestionMarksTotal(
    assignment,
    questionId
  );
}

export function getAssignmentQuizMarksTotal(
  assignments: Map<string, StudentAssignment>,
  assignmentId: string,
  quizId: string
) {
  const assignment = getAssignment(
    assignments as any,
    assignmentId
  ) as StudentAssignment;

  return studentAssignment.getAssignmentQuizMarksTotal(assignment, quizId);
}

export function getAssignmentQuizBestMarks(
  assignments: Map<string, StudentAssignment>,
  assignmentId: string,
  quizId: string
) {
  const assignment = getAssignment(
    assignments as any,
    assignmentId
  ) as StudentAssignment;

  return studentAssignment.getAssignmentQuizBestMarks(assignment, quizId);
}

export function getAssignmentQuizModulesAverageBestMarks(
  assignments: Map<string, StudentAssignment>,
  assignmentId: string,
  quizId: string
) {
  const assignment = getAssignment(
    assignments as any,
    assignmentId
  ) as StudentAssignment;

  return studentAssignment.getAssignmentQuizModulesAverageBestMarks(
    assignment,
    quizId
  );
}

export function isAssignmentQuestionFlagged(
  assignments: Map<string, StudentAssignment>,
  assignmentId: string,
  questionId: string
) {
  const assignment = getAssignment(
    assignments as any,
    assignmentId
  ) as StudentAssignment;

  return studentAssignment.isAssignmentQuestionFlagged(assignment, questionId);
}

export function wordHasBeenStudied(
  assignments: Map<string, StudentAssignment>,
  assignmentId: string,
  wordId: string
) {
  const assignment = getAssignment(
    assignments as any,
    assignmentId
  ) as StudentAssignment;

  return studentAssignment.wordHasBeenStudied(assignment, wordId);
}
